import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import "./Dashboard.css";

// ==========================================================
// ORGANIZATION LOGO
// ==========================================================

import logo from "../../assets/images/Logo.jpeg";

// ==========================================================
// DASHBOARD
// ==========================================================

function Dashboard() {
  const navigate = useNavigate();

  // ========================================================
  // MEMBER DATA
  // ========================================================

  const [memberData, setMemberData] = useState({});

  useEffect(() => {
    loadMemberData();
  }, []);

  const loadMemberData = () => {
    try {
      const registrationData =
        JSON.parse(
          localStorage.getItem("registrationData")
        ) || {};

      const paymentData =
        JSON.parse(
          localStorage.getItem("paymentData")
        ) || {};

      setMemberData({
        ...registrationData,
        ...paymentData,
      });
    } catch (error) {
      console.error(
        "Unable to load member data:",
        error
      );
    }
  };

  // ========================================================
  // MEMBER INFORMATION
  // ========================================================

  const memberName =
    memberData.fullName ||
    memberData.memberName ||
    "Krishna";

  const mobileNumber =
    memberData.mobileNumber ||
    memberData.mobile ||
    "+91 91234 56789";

  const email =
    memberData.email ||
    "member@email.com";

  const memberId =
    memberData.membershipId ||
    localStorage.getItem("membershipId") ||
    "APNBM15507750";

  const paymentAmount =
    memberData.amount ??
    memberData.paymentAmount ??
    localStorage.getItem("paymentAmount") ??
    "1199";

  // ========================================================
  // MEMBERSHIP VALID TILL
  // ========================================================

  const getValidTill = () => {
    const savedValidTill =
      localStorage.getItem(
        "membershipValidTill"
      );

    if (savedValidTill) {
      return savedValidTill;
    }

    if (memberData.validTill) {
      return memberData.validTill;
    }

    const date = new Date();

    date.setFullYear(
      date.getFullYear() + 1
    );

    date.setDate(
      date.getDate() - 1
    );

    return date.toLocaleDateString(
      "en-IN",
      {
        day: "2-digit",
        month: "short",
        year: "numeric",
      }
    );
  };

  const validTill = getValidTill();

  // ========================================================
  // CURRENT DATE & TIME
  // ========================================================

  const [currentDateTime, setCurrentDateTime] =
    useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentDateTime(new Date());
    }, 60000);

    return () => clearInterval(timer);
  }, []);

  const formattedDate =
    currentDateTime.toLocaleDateString(
      "en-IN",
      {
        day: "2-digit",
        month: "short",
        year: "numeric",
      }
    );

  const formattedTime =
    currentDateTime.toLocaleTimeString(
      "en-IN",
      {
        hour: "2-digit",
        minute: "2-digit",
      }
    );

  // ========================================================
  // NAVIGATION
  // ========================================================

  const goTo = (path) => {
    navigate(path);
  };

  // ========================================================
  // QUICK ACTIONS
  // ========================================================

  const quickActions = [
    {
      icon: "⇩",
      title: "Download",
      subtitle: "ID Card",
      color: "blue",
      path: "/id-card",
    },

    {
      icon: "▤",
      title: "Download",
      subtitle: "Receipt",
      color: "green",
      path: "/payment-history",
    },

    {
      icon: "♢",
      title: "Apply for",
      subtitle: "Claim",
      color: "purple",
      path: "/claims",
    },

    {
      icon: "♙",
      title: "Update",
      subtitle: "Profile",
      color: "orange",
      path: "/profile",
    },

    {
      icon: "♧",
      title: "Refer &",
      subtitle: "Earn",
      color: "red",
      path: "/refer-earn",
    },

    {
      icon: "✿",
      title: "View",
      subtitle: "Benefits",
      color: "purple",
      path: "/benefits",
    },

    {
      icon: "♧",
      title: "Support",
      subtitle: "Ticket",
      color: "green",
      path: "/support",
    },

    {
      icon: "♧",
      title: "Notifications",
      subtitle: "",
      color: "orange",
      path: "/notifications",
    },
  ];

  // ========================================================
  // NOTIFICATIONS
  // ========================================================

  const notifications = [
    {
      icon: "✓",
      type: "success",
      title:
        "Your membership is successfully activated.",
      description:
        "Thank you for being a part of our family.",
      date: "Today",
    },

    {
      icon: "▤",
      type: "info",
      title:
        "Education Support Program registration is now open.",
      description:
        "Apply now and benefit your children.",
      date: "Recent",
    },

    {
      icon: "♧",
      type: "warning",
      title:
        "Annual General Meeting information available.",
      description:
        "More details will be shared soon.",
      date: "Recent",
    },
  ];

  // ========================================================
  // BENEFITS
  // ========================================================

  const benefits = [
    "Family Protection & Support",
    "Financial Assistance",
    "Claim Support",
    "Education Support",
    "24/7 Member Support",
  ];

  // ========================================================
  // IMPORTANT LINKS
  // ========================================================

  const importantLinks = [
    {
      title: "How to Apply Claim",
      path: "/claims",
    },

    {
      title: "Claim Documents List",
      path: "/claims",
    },

    {
      title: "Terms & Conditions",
      path: "/terms",
    },

    {
      title: "Privacy Policy",
      path: "/privacy",
    },

    {
      title: "Help Center",
      path: "/support",
    },
  ];

  // ========================================================
  // DASHBOARD
  // ========================================================

  return (
    <div className="dashboard-home">

      {/* ==================================================
          WELCOME SECTION
      ================================================== */}

      <section className="welcome-section">

        <div className="welcome-content">

          <h2>
            Welcome Back,{" "}
            <span>{memberName}</span> 👋
          </h2>

          

        </div>

        <div className="current-time">

          Today is,{" "}

          <strong>
            {formattedDate} | {formattedTime}
          </strong>

        </div>

      </section>


      {/* ==================================================
          STATUS CARDS
      ================================================== */}

      <section className="status-grid">

        {/* MEMBERSHIP STATUS */}

        <div className="status-card">

          <div className="status-icon purple">
            ♙
          </div>

          <div className="status-content">

            <h3>
              Membership Status
            </h3>

            <span className="status-badge active">
              Active
            </span>

            <p>
              Valid till {validTill}
            </p>

          </div>

        </div>


        {/* PAYMENT STATUS */}

        <div className="status-card">

          <div className="status-icon blue">
            ▣
          </div>

          <div className="status-content">

            <h3>
              Payment Status
            </h3>

            <span className="status-badge paid">
              Paid
            </span>

            <strong className="amount">

              ₹
              {Number(paymentAmount).toLocaleString(
                "en-IN",
                {
                  minimumFractionDigits: 2,
                }
              )}

            </strong>

            <p>
              Paid successfully
            </p>

          </div>

        </div>


        {/* MEMBER ID */}

        <div className="status-card">

          <div className="status-icon orange">
            ▤
          </div>

          <div className="status-content">

            <h3>
              Member ID
            </h3>

            <strong className="member-id-value">
              {memberId}
            </strong>

            <button
              type="button"
              className="view-link"
              onClick={() =>
                goTo("/membership-details")
              }
            >
              View Details
            </button>

          </div>

        </div>


        {/* CLAIM STATUS */}

        <div className="status-card">

          <div className="status-icon green">
            ♢
          </div>

          <div className="status-content">

            <h3>
              Claims Status
            </h3>

            <strong className="claim-status">
              No Claim
            </strong>

            <p>
              Submitted Yet
            </p>

            <button
              type="button"
              className="view-link"
              onClick={() =>
                goTo("/claims")
              }
            >
              Apply for Claim
            </button>

          </div>

        </div>

      </section>


      {/* ==================================================
          MIDDLE GRID
      ================================================== */}

      <section className="middle-grid">

        {/* =================================================
            QUICK ACTIONS
        ================================================= */}

        <div className="panel quick-actions-panel">

          <div className="panel-header">

            <h2>
              Quick Actions
            </h2>

          </div>

          <div className="quick-actions">

            {quickActions.map(
              (action) => (

                <button
                  type="button"
                  key={
                    action.title +
                    action.subtitle
                  }
                  className="quick-action"
                  onClick={() =>
                    goTo(action.path)
                  }
                >

                  <span
                    className={`action-icon ${action.color}`}
                  >
                    {action.icon}
                  </span>

                  <strong>

                    {action.title}

                    {action.subtitle && (
                      <>
                        <br />
                        {action.subtitle}
                      </>
                    )}

                  </strong>

                </button>

              )
            )}

          </div>

        </div>


        {/* =================================================
            MEMBERSHIP CARD
        ================================================= */}

        <div className="panel membership-card-panel">

          <div className="panel-header">

            <h2>
              Membership Card
            </h2>

            <button
              type="button"
              className="panel-link"
              onClick={() =>
                goTo("/id-card")
              }
            >
              View / Download
            </button>

          </div>


          <div className="membership-card">

            {/* =================================================
                MEMBERSHIP CARD HEADER
            ================================================= */}

            <div className="membership-card-top">

              {/* ACTUAL ORGANIZATION LOGO */}

              <div className="card-logo">

                <img
                  src={logo}
                  alt="ABNB Seva Samithi & Vidya Charitable Trust Logo"
                />

              </div>


              {/* ORGANIZATION NAME */}

              <div className="card-title">

                <h2>
                  ABNB SEVA SAMITHI
                </h2>

                <h3>
                  &amp; VIDYA CHARITABLE TRUST
                </h3>

                <p>
                  Serve The Community.
                  Secure The Future.
                </p>

              </div>


              {/* WATERMARK */}

              <div className="card-watermark">
                ABNB
              </div>

            </div>


            {/* =================================================
                MEMBERSHIP CARD BODY
            ================================================= */}

            <div className="membership-card-body">

              {/* MEMBER PHOTO */}

              <div className="member-photo">

                {memberData.photo ? (

                  <img
                    src={memberData.photo}
                    alt={memberName}
                  />

                ) : (

                  <span>
                    {memberName
                      .charAt(0)
                      .toUpperCase()}
                  </span>

                )}

              </div>


              {/* MEMBER INFORMATION */}

              <div className="card-member-info">

                <h3>
                  {memberName}
                </h3>

                <p>

                  <span>
                    Member ID:
                  </span>

                  <strong>
                    {memberId}
                  </strong>

                </p>

                <p>

                  <span>
                    Mobile:
                  </span>

                  <strong>
                    {mobileNumber}
                  </strong>

                </p>

                <p>

                  <span>
                    Valid Till:
                  </span>

                  <strong>
                    {validTill}
                  </strong>

                </p>

              </div>


              {/* QR CODE */}

              <div className="qr-code">

                <div className="qr-pattern">

                  <span className="qr-square one" />
                  <span className="qr-square two" />
                  <span className="qr-square three" />
                  <span className="qr-square four" />
                  <span className="qr-square five" />
                  <span className="qr-square six" />
                  <span className="qr-square seven" />
                  <span className="qr-square eight" />
                  <span className="qr-square nine" />

                </div>

              </div>

            </div>


            {/* =================================================
                MEMBERSHIP CARD FOOTER
            ================================================= */}

            <div className="membership-card-bottom">

              Trusted by Thousands of Families

            </div>

          </div>

        </div>

      </section>


      {/* ==================================================
          LOWER GRID
      ================================================== */}

      <section className="lower-grid">

        {/* =================================================
            LATEST NOTIFICATIONS
        ================================================= */}

        <div className="panel notifications-panel">

          <div className="panel-header">

            <h2>
              Latest Notifications
            </h2>

            <button
              type="button"
              className="panel-link"
              onClick={() =>
                goTo("/notifications")
              }
            >
              View All
            </button>

          </div>


          <div className="notification-list">

            {notifications.map(
              (notification) => (

                <div
                  className="notification-item"
                  key={notification.title}
                >

                  <div
                    className={`notification-icon ${notification.type}`}
                  >
                    {notification.icon}
                  </div>

                  <div className="notification-text">

                    <strong>
                      {notification.title}
                    </strong>

                    <p>
                      {notification.description}
                    </p>

                  </div>

                  <span className="notification-date">
                    {notification.date}
                  </span>

                </div>

              )
            )}

          </div>

        </div>


        {/* =================================================
            BENEFITS
        ================================================= */}

        <div className="panel benefits-panel">

          <div className="panel-header">

            <h2>
              Our Benefits
            </h2>

            <button
              type="button"
              className="panel-link"
              onClick={() =>
                goTo("/benefits")
              }
            >
              View All
            </button>

          </div>


          <div className="benefit-list">

            {benefits.map(
              (benefit) => (

                <div
                  className="benefit-item"
                  key={benefit}
                >

                  <div className="benefit-icon">
                    ✓
                  </div>

                  <span>
                    {benefit}
                  </span>

                  <strong>
                    ✓
                  </strong>

                </div>

              )
            )}

          </div>

        </div>


        {/* =================================================
            PROFILE SUMMARY
        ================================================= */}

        <div className="profile-card">

          <div className="profile-top">

            <div className="profile-avatar">

              {memberName
                .charAt(0)
                .toUpperCase()}

            </div>

            <h2>
              {memberName}
            </h2>

            <p>
              Active Member
            </p>

            <span>
              MEMBER
            </span>

          </div>


          <div className="profile-details">

            <label>
              Member ID
            </label>

            <strong>
              {memberId}
            </strong>


            <label>
              Mobile
            </label>

            <strong>
              {mobileNumber}
            </strong>


            <label>
              Email
            </label>

            <strong>
              {email}
            </strong>


            <button
              type="button"
              onClick={() =>
                goTo("/profile")
              }
            >
              VIEW PROFILE
            </button>

          </div>

        </div>

      </section>


      {/* ==================================================
          SUPPORT GRID
      ================================================== */}

      <section className="support-grid">

        {/* =================================================
            IMPORTANT LINKS
        ================================================= */}

        <div className="panel important-links-panel">

          <div className="panel-header">

            <h2>
              Important Links
            </h2>

          </div>


          <div className="important-links">

            {importantLinks.map(
              (link) => (

                <button
                  type="button"
                  key={link.title}
                  onClick={() =>
                    goTo(link.path)
                  }
                >

                  <span>
                    {link.title}
                  </span>

                  <strong>
                    ›
                  </strong>

                </button>

              )
            )}

          </div>

        </div>


        {/* =================================================
            NEED HELP
        ================================================= */}

        <div className="help-card">

          <h2>
            Need Help?
          </h2>

          <p>
            Our support team is here to help you.
          </p>


          <div className="help-line">

            <span>
              ☎
            </span>

            <span>
              +91 91234 56789
            </span>

          </div>


          <div className="help-line">

            <span>
              ✉
            </span>

            <span>
              support@apnbtrust.org
            </span>

          </div>


          <div className="help-line">

            <span>
              ◷
            </span>

            <span>
              Mon - Sat: 9:00 AM - 6:00 PM
            </span>

          </div>


          <button
            type="button"
            onClick={() =>
              goTo("/support")
            }
          >
            RAISE SUPPORT TICKET
          </button>

        </div>

      </section>

    </div>
  );
}

export default Dashboard;